import React, { useState, useEffect, useContext } from "react";
import { Modal, Button } from "react-bootstrap";

import DatePicker from "react-date-picker";
import "react-calendar/dist/Calendar.css";
import "react-date-picker/dist/DatePicker.css";

import SuccessPopupModal from "../../components/SuccessPopupModal";
import { useAuth } from "../../../Context/AuthContext";
import { addUpdateBlog, GetBlogModal } from "../../../Services/Blog/BlogApi";
import { ERROR_MESSAGES } from "../../components/GlobalMassage";
import { addUpdateGallaryCat, GetGallaryCatData } from "../../../Services/Gallery Api/GalleryApi";

const GalleryAddUpdateModal = ({
  show,
  onHide,
  setIsAddUpdateActionDone,
  modelRequestData,
}) => {
  const [modelAction, setModelAction] = useState("");
  const [error, setErrors] = useState(null);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState();

  const { setLoader, user } = useAuth();


  const [galleryObj, setGalleryObj] = useState({
    

    gallaryCatName:null,
    gallaryCatKeyID:null,
    gallaryCatImage:null,

  });



  useEffect(() => {
    // debugger
    if (modelRequestData?.Action === "Update") {
      if (modelRequestData?.GallaryCatKeyID !== null) {
        GetBlogModalData(modelRequestData.GallaryCatKeyID);
      }
    }
  }, [modelRequestData?.Action]);

  const AddCustomerBtnClick = async () => {
    // debugger
    let isValid = false;

    if (
      galleryObj.gallaryCatName === null ||
      galleryObj.gallaryCatName === undefined ||
      galleryObj.gallaryCatName === "" ||
      galleryObj.gallaryCatImage === null ||
      galleryObj.gallaryCatImage === undefined ||
      galleryObj.gallaryCatImage === "" 
      
    ) {
      setErrors(true);
      isValid = true;
    }  else {
      setErrors(false);
      isValid = false;
    }

    const apiParam = {
     
      gallaryCatImage: galleryObj.gallaryCatImage,
      gallaryCatName: galleryObj.gallaryCatName,
      gallaryCatKeyID: galleryObj.gallaryCatKeyID,
      
    };
    if (!isValid) {
      AddUpdateCustomerData(apiParam);
    }
  };

  const AddUpdateCustomerData = async (apiParam) => {
    // debugger
    setLoader(true);
    try {
      let url = "/addUpdateGallaryCat"; // Default URL for Adding Data

      const response = await addUpdateGallaryCat(url, apiParam);
      if (response) {
        if (response?.data?.statusCode === 200) {
          setLoader(false);
          // debugger
          setShowSuccessModal(true);
          setModelAction(
            modelRequestData.Action === null ||
              modelRequestData.Action === undefined
              ? "Gallery Added Successfully!"
              : "Gallery Updated Successfully!"
          ); //Do not change this naming convention

          setIsAddUpdateActionDone(true);
        } else {
          setLoader(false);
          setErrorMessage(response?.response?.data?.errorMessage);
        }
      }
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };

  const handleImageChange = (e, fieldName) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 204800) {
        alert("Image size should be 200KB or less.");
        return;
      }
      const reader = new FileReader();
      reader.onloadend = () => {
        setGalleryObj((prev) => ({
          ...prev,
          [fieldName]: reader.result, // set base64
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleRemoveImage = (fieldName) => {
    setGalleryObj((prev) => ({
      ...prev,
      [fieldName]: null,
    }));
  };
  const GetBlogModalData = async (id) => {
    setLoader(true);
    if (id === undefined) {
      return;
    }

    try {
      const data = await GetGallaryCatData(id);
      if (data?.data?.statusCode === 200) {
        setLoader(false);

        const ModelData = data.data.responseData.data; // Assuming data is an array

        setGalleryObj({
          ...galleryObj,
          gallaryCatName: ModelData.GallaryCatName,
          gallaryCatImage: ModelData.gallaryCatImage,
          gallaryCatKeyID: ModelData.GallaryCatKeyID
         
        });
      } else {
        setLoader(false);
        // Handle non-200 status codes if necessary
        console.error("Error fetching data: ", data?.data?.statusCode);
      }
    } catch (error) {
      setLoader(false);
      console.error("Error in Customer : ", error);
    }
  };

  console.log(galleryObj.Title, "kdjsgauhydsa");

  const closeAllModal = () => {
    onHide();
    setShowSuccessModal(false);
  };

  const handleDescriptionChange = (htmlContent) => {
    setGalleryObj((obj) => ({
      ...obj,
      blogDescription: htmlContent,
    }));
  };

  const handleDateChange = (event) => {
    const selectedDate = event.target.value; // Gets the publishDate in "YYYY-MM-DD" format
    setGalleryObj((prev) => ({
      ...prev,
      publishDate: selectedDate,
    }));
  };
  return (
    <>
    {show && <div className="custom-backdrop" />}
      <Modal
        size="md"
        show={show}
        style={{ zIndex: 1300 }}
        onHide={onHide}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <>
            <h4 className="text-center project-main-mode text-dark">
              {modelRequestData?.Action !== null
                ? "Update Gallery"
                : modelRequestData?.Action === null
                ? "Add Gallery"
                : ""}
            </h4>
          </>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: "55vh", overflow: "overlay" }}>
          <div className="container">
            <div className="row">
              <div className="col-12 col-md-12 mb-2">
                <div>
                  <label htmlFor="clientName" className="form-label">
                   Gallery Category Name
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="clientName"
                    placeholder="Enter Gallery Category Name"
                    aria-describedby="Employee"
                    value={galleryObj.gallaryCatName}
                    onChange={(e) => {
                      setErrorMessage(false);
                      let inputValue = e.target.value;
                      // If the input is empty or starts with a space, prevent the space
                      if (
                        inputValue.length === 0 ||
                        (inputValue.length === 1 && inputValue === " ")
                      ) {
                        inputValue = "";
                      }
                      // Remove unwanted characters (keeping spaces that aren't at the start)
                      const cleanedValue = inputValue.replace(
                        /[^a-zA-Z0-9\s]/g,
                        ""
                      );

                      // Trim leading spaces while keeping internal spaces
                      const trimmedValue = cleanedValue.trimStart();

                      // Capitalize the first letter and keep the rest as is
                      const updatedValue =
                        trimmedValue.charAt(0).toUpperCase() +
                        trimmedValue.slice(1);

                      setGalleryObj((prev) => ({
                        ...prev,
                        gallaryCatName: updatedValue,
                      }));
                    }}
                  />

                  {error &&
                  (galleryObj.gallaryCatName === null ||
                    galleryObj.gallaryCatName === undefined ||
                    galleryObj.gallaryCatName === "") ? (
                    <span style={{ color: "red" }}>{ERROR_MESSAGES}</span>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-md-12 mb-2">
                <label className="form-label">Gallery Category Image:
                  <p className="small">Note:-(Upto 200kb) </p>
                </label>
                {galleryObj.gallaryCatImage ? (
                  <div
                    style={{ position: "relative", display: "inline-block" }}
                  >
                    <img
                      src={galleryObj.gallaryCatImage}
                      alt="Feature Preview"
                      style={{
                        maxWidth: "100%",
                        maxHeight: "200px",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                      }}
                    />
                    <button
                      type="button"
                      onClick={() => handleRemoveImage("gallaryCatImage")}
                      style={{
                        position: "absolute",
                        top: "5px",
                        right: "5px",
                        background: "rgba(255,255,255,0.8)",
                        border: "none",
                        borderRadius: "50%",
                        cursor: "pointer",
                        fontWeight: "bold",
                        padding: "2px 8px",
                      }}
                    >
                      ×
                    </button>
                  </div>
                ) : (
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => handleImageChange(e, "gallaryCatImage")}
                    className="form-control"
                  />
                )}

{error &&
                  (galleryObj.gallaryCatImage === null ||
                    galleryObj.gallaryCatImage === undefined ||
                    galleryObj.gallaryCatImage === "") ? (
                    <span style={{ color: "red" }}>{ERROR_MESSAGES}</span>
                  ) : (
                    ""
                  )}
              </div>
            </div>

            {/* <div className="row"> */}
          </div>

          {/* </div> */}
        </Modal.Body>
        <Modal.Footer>
          <Button className="rts-btn border bg-transparent" onClick={onHide}>
            Close
          </Button>
          <Button
            type="submit"
            style={{
              color: "white",
              backgroundColor: "#blue",
              borderColor: "#f08143",
            }}
            className=" rts-btn    text-center"
            onClick={() => AddCustomerBtnClick()}
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
      {showSuccessModal && (
        <SuccessPopupModal
          show={showSuccessModal}
          onHide={() => closeAllModal()}
          setShowSuccessModal={setShowSuccessModal}
          modelAction={modelAction}
        />
      )}
    </>
  );
};

export default GalleryAddUpdateModal;


